import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Shield, Mail, Lock, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import '../../styles/vds-auth.css';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const user = await login(email, password);
      toast.success('Welcome back!');
      
      // ADMIN STATUS SUPERSEDES ACCOUNT TYPE
      if (user.is_superadmin) {
        navigate('/admin'); // Go to Command Center Dashboard
      } else if (user.account_type === 'employer' || user.account_type === 'agency') {
        navigate('/employer/dashboard');
      } else {
        navigate('/employee/dashboard');
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="vds-auth-page">
      <div className="vds-auth-container">
        <div className="vds-auth-header">
          <Link to="/" className="vds-auth-logo">
            <div className="vds-auth-logo-mark">
              <Shield className="h-5 w-5" />
            </div>
            <span className="vds-auth-logo-text">VETT</span>
          </Link>
          <h1 className="vds-auth-title">Welcome back</h1>
          <p className="vds-auth-subtitle">Sign in to your account</p>
        </div>

        <div className="vds-auth-card">
          <form onSubmit={handleSubmit} className="vds-auth-form">
            <div className="vds-form-group">
              <label className="vds-form-label" htmlFor="email">Email</label>
              <div className="vds-input-wrapper">
                <Mail className="vds-input-icon h-5 w-5" />
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  className="vds-input"
                  required
                  data-testid="login-email-input"
                />
              </div>
            </div>

            <div className="vds-form-group">
              <label className="vds-form-label" htmlFor="password">Password</label>
              <div className="vds-input-wrapper">
                <Lock className="vds-input-icon h-5 w-5" />
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className="vds-input"
                  required
                  data-testid="login-password-input"
                />
              </div>
            </div>

            <div className="vds-auth-link-row">
              <Link to="/forgot-password" className="vds-auth-link">
                Forgot password?
              </Link>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="vds-btn-auth-primary"
              data-testid="login-submit-btn"
            >
              {loading ? (
                <>
                  <Loader2 className="h-4 w-4 animate-spin" />
                  Signing in...
                </>
              ) : (
                'SIGN IN'
              )}
            </button>
          </form>
        </div>

        <div className="vds-auth-footer">
          <p className="vds-auth-footer-text">
            Don&apos;t have an account?{' '}
            <Link to="/signup">Sign up</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
